module.exports = __webpack_public_path__ + "static/media/train4.42a3c40c.png";